import { addYears, endOfDay, startOfDay } from 'date-fns';
import {
  CertainDayPriceTypeList,
  BasePriceType,
  PriceVariant,
} from '../redux/types/pricesTypes';
import { getDateFromString } from './functions';

// считаем стоимость проживания за период / или 1 день
export const basePriceCalculator = (
  prices: BasePriceType,
  certainDayPrices: CertainDayPriceTypeList | null,
  date: Date,
) => {
  const currentYear = new Date().getFullYear();
  const prevYear = currentYear - 1;

  // console.log('basePriceCalculator 17 :', prices?.start_date);

  const startHighSeason = prices?.start_date
    ? startOfDay(getDateFromString(prices?.start_date))
    : new Date();
  const endHighSeason = prices.end_date
    ? endOfDay(getDateFromString(prices.end_date))
    : new Date();

  let anotheYearStartHighSeason: Date;
  let anotheYearEndHighSeason: Date;

  if (startHighSeason > endHighSeason) {
    startHighSeason.setFullYear(prevYear);
    endHighSeason.setFullYear(currentYear);
  }
  anotheYearStartHighSeason = addYears(startHighSeason, 1);
  anotheYearEndHighSeason = addYears(endHighSeason, 1);

  //считаем стоимость дня
  let priceDay = 0;
  const day = date.getDay(); //определяем день недели

  if (
    (date >= startHighSeason && date <= endHighSeason) ||
    (date >= anotheYearStartHighSeason && date <= anotheYearEndHighSeason)
  ) {
    // цена высокого сезона
    if (day === 5 || day === 6) {
      priceDay = Number(prices.high_season_weekend_price) || 0;
    } else {
      priceDay = Number(prices.high_season_weekday_price) || 0;
    }
  } else {
    // цена низкого сезона
    if (day === 5 || day === 6) {
      priceDay = Number(prices.low_season_weekend_price) || 0;
    } else {
      priceDay = Number(prices.low_season_weekday_price) || 0;
    }
  }

  if (certainDayPrices && certainDayPrices.length > 0) {
    certainDayPrices.forEach((certItem) => {
      if (
        date >= startOfDay(new Date(certItem.start_date)) &&
        date <= endOfDay(new Date(certItem.end_date))
      ) {
        priceDay = Number(certItem.base_price);
      }
    });
  }
  const answer = {
    summ: priceDay,
    variant: PriceVariant.REGULAR_HIGH,
    certId: 0,
  };
  return answer;
};
